import gql from 'graphql-tag'

export const ALL_IADES = gql`
  query{
    allIades{
      nodes{
        nom
        prenom
        id
        actif
      }
    }
  }
`

export const ALL_ACTIVES_IADES = gql`
  query{
    allIades(
      orderBy: NOM_ASC
      condition: {
        actif: true
      }
    ){
      nodes{
        nom
        prenom
        id
        actif
      }
    }
  }
`

export const UPDATE_IADE = gql`
mutation($id: Int!, $nom: String, $prenom: String, $email: String, $actif: Boolean){
    updateIadeById(input:{
      id: $id
      iadePatch:{
        nom: $nom
        prenom: $prenom
        email: $email
        actif: $actif
      }
    }){
      iade{
        id
        nom
        prenom
        email
        actif
      }
    }
  }
  `



// WEBPACK FOOTER //
// ./src/constants/iade.js